// Kampfsimulation (X2, §6): rein, deterministisch, ohne Grafik.
// Kennt weder Browser noch Darstellung; src/ui liest nur, was hier herauskommt.

export { createRng, type Rng } from './rng.ts';
export { createBattle, stepBattle, summarize, runBattle, validateSetup, marchReach, stormlingStats, fragileOf, type Battle } from './battle.ts';
export { createLive, liveAdvance, liveCommand, commandTick, type Live } from './battle/live.ts';
export { practiceSetup, kniffAim, comboPolicy, COMBO_PLACEMENT, type PracticePlacement } from './practice.ts';
export { xpPot, distributeXp, contributionScore } from './xp.ts';
export { rollTraits } from './traits.ts';
export type * from './types.ts';
export { FrameFlag, FrameFlag2 } from './types.ts';

// Run-Prototyp (Phase 4, R27)
export * from './run/run.ts';
export * from './run/posts.ts';
export * from './run/ending.ts';
export * from './run/profile.ts';
export * from './run/river.ts';
export { introText, topMemories, pennantLine } from './run/bonds.ts';
export * from './run/foes.ts';
export * from './run/auto.ts';
export * from './run/rarity.ts';
export type * from './run/types.ts';
export * from './luck.ts';
